import { Button, darken, styled } from '@mui/material'

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.custom.gray4};
  color: ${({ theme }) => theme.palette.custom.blue2};
  height: 40px;
  border: 1px solid ${({ theme }) => theme.palette.custom.blue2};
  border-radius: 6px;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 700;

  &:hover {
    background-color: ${({ theme }) =>
      darken(theme.palette.custom.gray4, 0.025)};
  }
`
